// extracted by mini-css-extract-plugin
export default {"cls1":"SnackBar-cls1_igU","cls2":"SnackBar-cls2_h2J SnackBar-cls1_igU"};